module.exports = "/images/vendor/flag-icon-css/flags/1x1/cu.svg?0b42edabb93ec1c4862f441f4151996e";